import {
    MessageTitle,
    OverlayContext,
    LoaderSpinner,
} from "@govtechsg/tradetrust-ui-components";
import React, { useContext, useEffect, useState } from "react";
import { Grid, Box } from '@material-ui/core';
import { FormState } from "../../constants/FormState";
import { isEthereumAddress } from "../../utils";
import AssetInformationPanel from "../AssetInformationPanel/index";
import { AssetManagementTitle } from "../AssetManagementTitle";
import { EditableAssetTitle } from "./EditableAssetTitle";
import SubmitButton from 'src/components/button/SubmitButton.js';
import CancelButton from 'src/components/button/CancelButton.js'
import FormBackButton from "../FormBackButton";
import Loading from '../Loading';
import { WalletAddressesMaxLength, PingStatusGeneralEventCode, PingStatusGeneralTransfer } from 'src/views/tradetrust/constants/TransferEventStatuses'


export const TransferHolderForm = ({
    formAction,
    tokenRegistryAddress,
    beneficiary,
    holder,
    handleTransfer,
    holderTransferringState,
    setFormActionNone,
    setShowEndorsementChain,
    setConfirmDialogOpen,
    setModalData,
    sendPingMilestone,
    blNumber,
    walletAddressesMapping,
    pingStatusMapping,
    pingMilestone,
    processPingMilestone
}) => {
    const [newHolder, setNewHolder] = useState("");
    const isPendingConfirmation = holderTransferringState === FormState.PENDING_CONFIRMATION;
    const isConfirmed = holderTransferringState === FormState.CONFIRMED;
    const isEditable = holderTransferringState !== FormState.PENDING_CONFIRMATION && holderTransferringState !== FormState.CONFIRMED;
    const { showOverlay } = useContext(OverlayContext);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (isConfirmed) {
            const arrMsg = [
                { id: 1, value: MessageTitle.TRANSFER_HOLDER_SUCCESS },
                { id: 2, value: <br /> },
                { id: 3, value: <br /> },
                { id: 4, value: 'Current Holder:' },
                { id: 5, value: <br /> },
                { id: 6, value: newHolder }
            ];
            setModalData({
                content: arrMsg.map(msg => (msg.value)),
                title: 'Success',
                okMsg: 'Close',
                type: 'Info'
            })
            setLoading(false);
            setConfirmDialogOpen(true);

            //PING Milestone processing and sending to the PING API endpoint
            let pingMilestoneRequest = processPingMilestone(pingMilestone, newHolder);
            sendPingMilestone(pingMilestoneRequest);

            setFormActionNone();
        }
    }, [isConfirmed, newHolder, showOverlay, setFormActionNone]);

    const isValidTransfer = () => {
        if (!newHolder) return false;
        if (newHolder === holder) return false;
        if (!isEthereumAddress(newHolder)) return false;

        return true;
    };

    useEffect(() => {
        if (holderTransferringState === FormState.ERROR) {
            setLoading(false);
        }
    }, [holderTransferringState])



    return (
        <>
            <Loading loading={loading}>
                <FormBackButton
                    setFormActionNone={setFormActionNone}
                />
                <AssetManagementTitle
                    setFormActionNone={setFormActionNone}
                    formAction={formAction}
                    disabled={isPendingConfirmation}
                />

                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <AssetInformationPanel
                            setShowEndorsementChain={setShowEndorsementChain}
                            tokenRegistryAddress={tokenRegistryAddress}
                        />
                    </Grid>
                    <Grid item xs={4} style={{ overflowWrap: 'anywhere' }}>
                        <EditableAssetTitle role="Owner" value={beneficiary} isEditable={false} />
                    </Grid>
                    <Grid item xs={4} style={{ overflowWrap: 'anywhere' }}>
                        <EditableAssetTitle
                            role="Holder"
                            value={holder}
                            newValue={newHolder}
                            isEditable={isEditable}
                            onSetNewValue={setNewHolder}
                            isError={holderTransferringState === FormState.ERROR}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item style={{ overflowWrap: 'anywhere' }}>
                        <Box ml={3}>
                            <CancelButton onClick={setFormActionNone} disabled={isPendingConfirmation} />
                        </Box>
                    </Grid>
                    <Grid item style={{ overflowWrap: 'anywhere' }}>
                        <SubmitButton
                            onClick={() => {
                                handleTransfer(newHolder);
                                setLoading(true);
                            }}
                            disabled={!isValidTransfer() || isPendingConfirmation}
                        >
                            {isPendingConfirmation ? <LoaderSpinner data-testid={"loader"} /> : <>Transfer</>}
                        </SubmitButton>
                    </Grid>
                </Grid>
            </Loading>
        </>
    );
};